module.exports = __webpack_public_path__ + "assets/2f5f5dec75506a5c38a2d37c7ce272be.mp3";